import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { DEBUG_ROUTES_WITH_INLINE_MODALS } from '#/components/dev/constants';
import { useRouterLocation } from '#/components/hooks';

/**
 * Display Modals and Mobile Full-size pages globally so we can use them in any environment.
 * Eg. inside Tables (otherwise very problematic), grid, flex, etc
 * without interfering with parent styles.
 *
 * Can be used multiple times at once. Will display all as siblings.
 */
export default function ModalGlobalPortal({
  children,
}: {
  children: ReactNode;
}) {
  const { pathname } = useRouterLocation();
  if (DEBUG_ROUTES_WITH_INLINE_MODALS.some(path => path === pathname)) {
    // Render inline on Modal showcase pages
    return <>{children}</>;
  }
  const rootModals = document.getElementById('rootModals');
  if (!rootModals) {
    console.error('Setup error: rootModals missing');
    return null;
  }
  return createPortal(children, rootModals);
}
